import AOS from "aos";
import "aos/dist/aos.css";

jQuery(($) => {
	AOS.init({ disable: "mobile" });

	$(window).on("load", function () {
		AOS.refresh();
	});

	/****************** POPUP ******************/

	let popit = 0;
	let popClicked = 0;

	if ($(".more-link").length > 0) {
		$(".more-link").on("click", function () {
			$(".col-right").hide();
			$(".col-left").addClass("active");

			$(".col-more").toggleClass("active");
			$(".more-link").hide();
			$(".more-link-close").show();
		});

		$(".more-link-close").on("click", function () {
			$(".col-more").toggleClass("active");
			$(".more-link").show();
			$(".more-link-close").hide();

			$(".col-right").show();
			$(".col-left").removeClass("active");
		});
	}

	if ($(".popup").length > 0) {
		$(".popup-button, .close-popup-icon").on("click", function () {
			popit++;

			const classList = $(this).attr("class").split(" ");
			$(`#${classList[1]}`).toggleClass("show");
			$("body").addClass("is--popped");

			popClicked = 1;
		});

		$(document).on("click", function (e) {
			if (
				!$(e.target).closest(".popup-interior-copy").length &&
				popit >= 1 &&
				popClicked != 1
			) {
				if ($(".popup.show").is(":visible")) {
					$(".disclaimer").fadeOut();
					$(".popup.show").removeClass("show");
					$("body").removeClass("is--popped");
					console.log("clicked");
					popit = 0;
				}
			} else {
				popClicked = 0;
			}
		});
	}

	/****************** TOOLTIP HOVER ******************/

	let tool = 0;
	let justClicked = 0;

	if (window.innerWidth < 1024) {
		$(".info-icon").on("click", function () {
			tool++;
			$(".disclaimer").removeClass("active").fadeOut();
			$(this).siblings(".disclaimer").fadeIn("active");
			justClicked = 1;
		});

		if ($(".tooltip-container.disclaimer").length > 0) {
			$(document).on("click", function (e) {
				if (
					!$(e.target).next(".disclaimer").length &&
					tool >= 1 &&
					justClicked != 1
				) {
					if ($(".tooltip-container.disclaimer").is(":visible")) {
						$(".disclaimer").fadeOut();
						tool = 0;
					}
				} else {
					justClicked = 0;
				}
			});
		}
	}

	/**/

	/* $(".info-icon").on("hover", function () {
		$(".disclaimer").fadeOut();
		$(this).siblings(".disclaimer").fadeToggle();
	}); */
	if (window.innerWidth > 1023) {
		$(".info-icon")
			.on("mouseenter", handlerIn)
			.on("mouseleave", handlerOut);

		function handlerIn() {
			$(this).siblings(".disclaimer").fadeIn();
		}

		function handlerOut() {
			$(this).siblings(".disclaimer").fadeOut();
		}
	}

	/****************** BACKGROUND IMAGE EXPANDER ******************/

	/* if ($(".background-image").length > 0) {
        const animatedDiv = document.querySelector(".background-image");

        let initialPadding = 60;
        let padding = initialPadding;

        let scrollingAllowed = true;

        function updatePadding() {
            const scrollPosition = window.scrollY;

            const targetPadding = initialPadding - scrollPosition * 0.2; // Adjust the speed by changing the multiplier
            const easingFactor = 0.08; // Adjust this value for smoother or faster animation
            padding += (targetPadding - padding) * easingFactor;

            animatedDiv.style.padding = `0 ${Math.max(
                0,
                padding,
            )}px 0 ${Math.max(0, padding)}px`;

            if (padding <= 0) {
                scrollingAllowed = false;
            } else if (padding > 0) {
                scrollingAllowed = true;
            }

            requestAnimationFrame(updatePadding);
        }

        window.addEventListener("scroll", updatePadding);

        updatePadding();
    } */

	/****************** BUTTON STYLE ******************/

	/* $(".btn, .dealer a, button.gform_button")
		.on("mouseenter", function (e) {
			var parentOffset = $(this).offset(),
				relX = e.pageX - parentOffset.left,
				relY = e.pageY - parentOffset.top;
			$(this).find("span").css({ top: relY, left: relX });
		})
		.on("mouseout", function (e) {
			var parentOffset = $(this).offset(),
				relX = e.pageX - parentOffset.left,
				relY = e.pageY - parentOffset.top;
			$(this).find("span").css({ top: relY, left: relX });
		});
 */
	/****************** CHANGE DATEPICKER ICON ******************/

	if ($(".ui-datepicker-trigger").length > 0) {
		$(".ui-datepicker-trigger").attr(
			"src",
			"/wp-content/themes/outfest/assets/dist/images/datepicker.svg",
		);
	}

	/****************** HAMBURGERS MENU ******************/

	$("#header").on("click", "button.navbar-toggler", function () {
		$(this).toggleClass("is-active");
		$("main#main").toggleClass("is--open");
		$("nav#header").toggleClass("menu-open");
		$("body").toggleClass("is--open");
	});

	$(".mobile-menu li a").on("click", function () {
		$("main#main").toggleClass("is--open");
		$("nav#header").toggleClass("menu-open");
		$("body").toggleClass("is--open");
		$("button.navbar-toggler").toggleClass("is-active");
	});

	/****************** HAMBURGERS MENU DROPDOWN ******************/

	$(".mobile-menu li.dropdown").on("click", function () {
		$(this).toggleClass("active");
	});

	/****************** ACCORDIONS ******************/

	$(".accord:has(div ul li.active)").addClass("active");

	$(".accord .header, .accord .answer").on("click", function () {
		var $parent = $(this).closest(".accord");

		if (!$parent.hasClass("active")) {
			$(".accord.active").removeClass("active");
			$parent.addClass("active");
		} else {
			$parent.removeClass("active");
		}
	});

	/****************** HIDE NAVBAR WHEN SCROLLING ******************/

	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	var $header = $("#header");
	var navbarHeight = $header.outerHeight();
	var st;

	$(window).on("resize scroll", function () {
		didScroll = true;
		st = $(window).scrollTop();

		/****************** STICKY SIDE ******************/

		/* if ($(".side-bar").length > 0) {
			if (st >= $(".spacer").offset().top + $(".spacer").outerHeight()) {
				$(".side-bar").addClass("sticky-side");
			} else {
				$(".side-bar").removeClass("sticky-side");
			}
		} */
	});

	setInterval(function () {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 0); //350

	function hasScrolled() {
		if (Math.abs(lastScrollTop - st) <= delta) return;

		if (st > lastScrollTop && st > navbarHeight) {
			$header.removeClass("expanded-header").addClass("nav-up");
		} else {
			if (st + $(window).height() < $(document).height()) {
				$header.removeClass("nav-up").addClass("expanded-header");
			}
		}

		lastScrollTop = st;
	}

	$(window).on("scroll", () => {
		if ($(window).scrollTop() === 0) {
			$("#header").removeClass("nav-up expanded-header");
		}
	});

	/****************** MOBILE DROPDOWN ******************/
	if (window.innerWidth < 1024) {
		if ($(".services-dropdown").length > 0) {
			$(".services-dropdown").on("click", function () {
				$(this).toggleClass("nav-is-visible");
			});

			$("#services-dropdown").on("change", function () {
				// Get the selected option's value
				console.log($(this).val());
				var selectedUrl = $(this).val();

				// Check if a valid URL is selected
				if (selectedUrl) {
					// Redirect to the selected URL
					window.location.href = selectedUrl;
				}
			});
		}
	}

	//let siteURL = window.location.origin;
	$("#menu-main-menu li a").each(function () {
		//console.log(this);
		if (window.location.href.indexOf("/services/") >= 0) {
			if (this.href.indexOf("/services/") >= 0) {
				$(this).parent().addClass("active");
				return false;
			}
		} else if (window.location.href.indexOf("/our-clients/") >= 0) {
			if (this.href.indexOf("/our-clients/") >= 0) {
				$(this).parent().addClass("active");
				return false;
			}
		} else if (window.location.href.indexOf("/blog/") >= 0) {
			/* if (this.href.indexOf("/blog/") >= 0) {
				console.log(window.location.href);
				console.log(this);
				$(this).siblings("li").addClass("active");
				$(this).children("li").addClass("active");
				return false;
			} */
		} else if (window.location.href.indexOf("/newsroom/") >= 0) {
			/* 	if (this.href.indexOf("/newsroom/") >= 0) {
				console.log(window.location.href);
				console.log(this);
				$(this).addClass("active");
				return false;
			} */
		}
	});

	/****************** Search ******************/

	var searchTimer;

	function performSearch() {
		$("#search-field").on("input", function () {
			let searchTerm = $("#search-field").val();
			console.log(searchTerm);
			if (searchTerm.length >= 2) {
				$.ajax({
					type: "POST",
					url: ajax_posts.ajaxurl,
					data: {
						action: "newsroom_search",
						search_term: searchTerm,
					},
					success: function (response) {
						$(".more-archive-container").hide();
						$("#archive--content").html(response);
					},
				});
			} else {
				// If search term is less than 3 characters, load the original content
				loadOriginalContent();
			}
		});
	}

	$("#search-field").on("input", function () {
		console.log(searchTimer);
		clearTimeout(searchTimer);
		searchTimer = setTimeout(performSearch, 500); // Delay before sending the AJAX request (in milliseconds)
	});

	function loadOriginalContent() {
		$.ajax({
			type: "POST",
			url: ajax_posts.ajaxurl,
			data: {
				action: "load_original_content",
			},
			success: function (response) {
				$(".more-archive-container").show();
				$("#archive--content").html(response);
			},
		});
	}

	// Handle the case when the search input is cleared
	$("#search-field").on("change", function () {
		if ($(this).val() === "") {
			loadOriginalContent();
		}
	});

	$("#search-field").keydown(function (event) {
		if (event.keyCode == 13) {
			console.log("Enter key pressed");
			event.preventDefault();
		}
	});

	/* var wall = $("#hawaiiwall");
	var movableDivRight = $("#cloud-right");
	var movableDivLeft = $("#cloud-left");

	var scrollSpeed = 0.3;

	if (window.innerWidth < 1024) {
		scrollSpeed = 2 + 1;
	}
	var windowHeight = $(window).height();
	var windowWidth = $(window).width();

	var movableDivRightWidth = movableDivRight.width();
	var movableDivLeftWidth = movableDivLeft.width();

	var initialLeft = movableDivLeft.offset().left;
	var initialRight =
		windowWidth -
		(movableDivRight.offset().left + movableDivRight.outerWidth()); */

	/* if (window.innerWidth < 1024) {
		var initialLeft = "-1";
		var initialRight = "-100%";
	} */

	//console.log(initialLeft + " " + initialRight);
	/*console.log(movableDivRightWidth + " " + movableDivLeftWidth); */

	/* 	$(window).on("scroll", function () {
		var scrollTop = $(window).scrollTop();
		var wallTop = wall.offset().top;
		var wallBottom = wallTop + wall.height();

		var wallVisible =
			scrollTop + windowHeight > wallTop && scrollTop < wallBottom;

		var maxLeft = windowWidth - movableDivLeftWidth;
		var maxRight = windowWidth - movableDivRightWidth;

		var left = initialLeft + scrollTop * scrollSpeed;
		var right = initialRight + scrollTop * scrollSpeed;

		if (wallVisible) {
			if (window.innerWidth >= 1024) {
				movableDivRight.css("left", right + "px");
				movableDivLeft.css("right", left + "px");

				movableDivLeft.css("left", "unset");
				movableDivRight.css("right", "unset");
			} else {
				var left =
					(scrollTop / (wallBottom - windowHeight)) *
					maxLeft *
					scrollSpeed;
				var right =
					(scrollTop / (wallBottom - windowHeight)) *
					maxRight *
					scrollSpeed;

				//console.log(left + " " + right);
				/ *
				movableDivRight.css("right", right + "px");
				movableDivLeft.css("left", left + "px"); * /
			}
		}
	}); */

	/* 	$("#enternow .btn").on("click", function () {
		$("#enternow").addClass("hidden");
		$("#sweepstakes").removeClass("hidden");
	}); */

	/** Sweepstakes deep links: #thankyou = new POST success; #entered = email already in sheet. */
	function applyCheersSweepstakesHash() {
		const h = window.location.hash;
		const $form = $('form[name="sweepstake-form"]');

		if (h === "#sweepstakes") {
			$("#sweepstakes").removeClass("hidden");
			$("#entered").addClass("hidden");
			$("#thankyou").addClass("hidden");
			if ($form.length) {
				$form.css("display", "");
			}
		} else if (h === "#thankyou") {
			$("#sweepstakes").addClass("hidden");
			$("#thankyou").removeClass("hidden");
			$("#entered").addClass("hidden");
			if ($form.length) {
				$form.css("display", "none");
			}
		} else if (h === "#entered") {
			if ($form.length) {
				$form.css("display", "none");
			}
			$("#entered").removeClass("hidden");
			$("#thankyou").addClass("hidden");
			const $entered = $("#entered");
			const $sweep = $("#sweepstakes");
			if (
				$sweep.length &&
				$entered.length &&
				!$sweep[0].contains($entered[0])
			) {
				$sweep.addClass("hidden");
			}
		}
	}

	applyCheersSweepstakesHash();
	$(window).on("hashchange", applyCheersSweepstakesHash);
});

/**
 * Sheet column header used for duplicate email lookup (must match row 1 of the sheet).
 */
const SHEETDB_EMAIL_SEARCH_KEY = "form_field_email";

const SHEETDB_API_BASE = "https://sheetdb.io/api/v1/kn3od7e0xcedd";

/**
 * Form → Sheet row. Object keys must match row 1 of the Google Sheet exactly.
 * If your headers differ (e.g. "Email" instead of "form_field_email"), set
 * `sheetColumn` to the header string; otherwise omit it (defaults to `name`).
 */
const SHEETDB_SWEEPSTAKE_FIELDS = [
	{ name: "form_field_name" },
	{ name: "form_field_last" },
	{ name: "form_field_zip" },
	{ name: "form_field_email" },
	{ name: "form_field_phone" },
	{ name: "form_field_rewards" },
	{ name: "form_field_submission" },
	{ name: "form_field_promotional_emails", type: "checkbox" },
];

function sheetDbSweepstakeRow(form) {
	const row = {};
	SHEETDB_SWEEPSTAKE_FIELDS.forEach(function (spec) {
		const col = spec.sheetColumn != null ? spec.sheetColumn : spec.name;
		const el = form.elements.namedItem(spec.name);
		if (!el) {
			return;
		}
		if (spec.type === "checkbox") {
			row[col] = el.checked ? "Yes" : "";
			return;
		}
		if ("value" in el) {
			row[col] = String(el.value).trim();
		}
	});
	return row;
}

/**
 * Duplicate check uses SheetDB search — param name must match the email column header.
 * @see https://docs.sheetdb.io/sheetdb-api/search
 */
function sheetDbSearchUrlForEmail(email) {
	const params = new URLSearchParams();
	params.set(SHEETDB_EMAIL_SEARCH_KEY, email.trim());
	params.set("limit", "1");
	return `${SHEETDB_API_BASE}/search?${params.toString()}`;
}

const SWEEPSTAKE_REQUIRED_TEXT_FIELDS = [
	"form_field_name",
	"form_field_last",
	"form_field_phone",
	"form_field_email",
	"form_field_zip",
];

function getSweepstakeControl(form, name) {
	const el = form.elements.namedItem(name);
	return el && "value" in el ? el : null;
}

function setFormMessageVisible(el, visible) {
	if (!el) {
		return;
	}
	el.classList.toggle("hidden", !visible);
	if (visible) {
		el.removeAttribute("hidden");
	} else {
		el.setAttribute("hidden", "");
	}
}

function setFieldInvalid(input, invalid) {
	if (!input) {
		return;
	}
	input.setAttribute("aria-invalid", invalid ? "true" : "false");
	input.classList.toggle("invalid", invalid);
	if (invalid) {
		input.classList.remove("valid");
	}
}

function hideSweepstakesFormErrors() {
	[
		"cheers-error",
		"cheers-error-checks",
		"cheers-rewards-error",
	].forEach(function (id) {
		setFormMessageVisible(document.getElementById(id), false);
	});
	const status = document.getElementById("sweepstake-form-status");
	if (status) {
		status.textContent = "";
	}
}

function clearSweepstakeFieldErrors(form) {
	SWEEPSTAKE_REQUIRED_TEXT_FIELDS.forEach(function (name) {
		const input = getSweepstakeControl(form, name);
		if (name === "form_field_zip") {
			setZipFieldValidity(input, "neutral");
		} else {
			setFieldInvalid(input, false);
		}
	});
	const rewardsInput = getSweepstakeControl(form, "form_field_rewards");
	if (rewardsInput) {
		rewardsInput.classList.remove("valid", "invalid");
		rewardsInput.setAttribute("aria-invalid", "false");
	}
}

function announceSweepstakeFormStatus(message) {
	const status = document.getElementById("sweepstake-form-status");
	if (status) {
		status.textContent = message;
	}
}

function focusSweepstakePanel(panel) {
	if (!panel) {
		return;
	}
	panel.setAttribute("tabindex", "-1");
	panel.focus();
}

function setRewardsFieldValidity(input, isValid) {
	if (!input) {
		return isValid;
	}
	input.classList.toggle("valid", isValid);
	setFieldInvalid(input, !isValid);
	setFormMessageVisible(
		document.getElementById("cheers-rewards-error"),
		!isValid,
	);
	return isValid;
}

function validateSweepstakeForm(form) {
	hideSweepstakesFormErrors();
	clearSweepstakeFieldErrors(form);

	let firstInvalid = null;
	let hasErrors = false;

	SWEEPSTAKE_REQUIRED_TEXT_FIELDS.forEach(function (name) {
		const input = getSweepstakeControl(form, name);
		const value = input ? String(input.value).trim() : "";
		if (!value) {
			setFieldInvalid(input, true);
			hasErrors = true;
			if (!firstInvalid) {
				firstInvalid = input;
			}
		}
	});

	const emailInput = getSweepstakeControl(form, "form_field_email");
	if (
		emailInput &&
		emailInput.value.trim() &&
		typeof emailInput.checkValidity === "function" &&
		!emailInput.checkValidity()
	) {
		setFieldInvalid(emailInput, true);
		hasErrors = true;
		if (!firstInvalid) {
			firstInvalid = emailInput;
		}
	}

	const zipInput = getSweepstakeControl(form, "form_field_zip");
	if (zipInput) {
		const zipValue = normalizeZipValue(zipInput.value);
		if (zipValue.length > 0 && zipValue.length < 5) {
			setZipFieldValidity(zipInput, "invalid");
			hasErrors = true;
			if (!firstInvalid) {
				firstInvalid = zipInput;
			}
		}
	}

	const rewardsInput = getSweepstakeControl(form, "form_field_rewards");
	const rewardsValue = rewardsInput ? String(rewardsInput.value).trim() : "";
	if (!isRewardsFieldValid(rewardsValue)) {
		setRewardsFieldValidity(rewardsInput, false);
		hasErrors = true;
		if (!firstInvalid) {
			firstInvalid = rewardsInput;
		}
	}

	const consent = document.getElementById("consent");
	if (!consent || !consent.checked) {
		setFormMessageVisible(
			document.getElementById("cheers-error-checks"),
			true,
		);
		hasErrors = true;
		if (!firstInvalid) {
			firstInvalid = consent;
		}
	}

	if (hasErrors) {
		announceSweepstakeFormStatus(
			"Please correct the errors below before submitting.",
		);
		if (firstInvalid) {
			firstInvalid.focus();
		}
		return false;
	}

	return true;
}

function isRewardsFieldValid(value) {
	const trimmed = String(value).trim();
	if (!trimmed) {
		return false;
	}
	return transformMbrCardNumber(trimmed);
}

/** New row saved — show thank-you panel and #thankyou hash. */
function cheersSuccess(form) {
	form.style.display = "none";

	const sweepstakes = document.getElementById("sweepstakes");
	if (sweepstakes) {
		sweepstakes.classList.add("hidden");
	}
	const thankyou = document.getElementById("thankyou");
	if (thankyou) {
		thankyou.classList.remove("hidden");
		focusSweepstakePanel(thankyou);
	}
	const entered = document.getElementById("entered");
	if (entered) {
		entered.classList.add("hidden");
	}

	window.location.hash = "thankyou";
}

/** Sheet already has this email — show already-entered panel and #entered hash. */
function cheersDuplicateEntry(form) {
	form.style.display = "none";

	const entered = document.getElementById("entered");
	if (entered) {
		entered.classList.remove("hidden");
		focusSweepstakePanel(entered);
	}
	const sweepstakes = document.getElementById("sweepstakes");
	if (sweepstakes && entered && !sweepstakes.contains(entered)) {
		sweepstakes.classList.add("hidden");
	}
	const thankyou = document.getElementById("thankyou");
	if (thankyou) {
		thankyou.classList.add("hidden");
	}

	window.location.hash = "entered";
}

function cheersError() {
	const err = document.getElementById("cheers-error");
	setFormMessageVisible(err, true);
	if (err) {
		err.focus();
	}
	announceSweepstakeFormStatus(
		"Looks like something went wrong. Check the form and try again.",
	);
}

function setSweepstakeFormBusy(form, busy) {
	const btn = form.querySelector("button.button");
	if (btn) {
		btn.disabled = busy;
		btn.setAttribute("aria-busy", busy ? "true" : "false");
	}
}

if (document.forms["sweepstake-form"]) {
	const form = document.forms["sweepstake-form"];

	form.addEventListener("submit", function (e) {
		e.preventDefault();

		if (!validateSweepstakeForm(form)) {
			return;
		}

		const emailInput = getSweepstakeControl(form, "form_field_email");
		const email = emailInput ? String(emailInput.value).trim() : "";
		const rewardsInput = getSweepstakeControl(form, "form_field_rewards");
		setRewardsFieldValidity(rewardsInput, true);
		setSweepstakeFormBusy(form, true);

		fetch(sheetDbSearchUrlForEmail(email), { method: "GET", mode: "cors" })
			.then(function (res) {
				if (!res.ok) {
					throw new Error("Sheet lookup failed");
				}
				return res.json();
			})
			.then(function (rows) {
				if (Array.isArray(rows) && rows.length > 0) {
					setSweepstakeFormBusy(form, false);
					cheersDuplicateEntry(form);
					return;
				}
				const row = sheetDbSweepstakeRow(form);
				return fetch(SHEETDB_API_BASE, {
					method: "POST",
					mode: "cors",
					headers: {
						"Content-Type": "application/json",
						Accept: "application/json",
					},
					body: JSON.stringify({ data: [row] }),
				}).then(function (response) {
					setSweepstakeFormBusy(form, false);
					if (!response.ok) {
						return response.text().then(function (t) {
							try {
								const errJson = JSON.parse(t);
								console.error("SheetDB POST error", response.status, errJson);
							} catch (ignore) {
								console.error(
									"SheetDB POST error",
									response.status,
									t || "(empty body)"
								);
							}
							throw new Error("Sheet save failed");
						});
					}
					cheersSuccess(form);
				});
			})
			.catch(function () {
				setSweepstakeFormBusy(form, false);
				cheersError();
			});
	});
}

if (document.getElementById("form_field_rewards")) {
	const rewards = document.getElementById("form_field_rewards");

	rewards.addEventListener("input", function () {
		const mbrCardNumber = rewards.value.trim();
		if (!mbrCardNumber) {
			rewards.classList.remove("valid", "invalid");
			rewards.setAttribute("aria-invalid", "false");
			setFormMessageVisible(
				document.getElementById("cheers-rewards-error"),
				false,
			);
			return;
		}
		setRewardsFieldValidity(
			rewards,
			transformMbrCardNumber(mbrCardNumber),
		);
	});
}

function transformMbrCardNumber(mbrCardNumber) {
	mbrCardNumber = String(mbrCardNumber).trim();
	if (!mbrCardNumber) {
		return false;
	}

	if (mbrCardNumber.length < 14) {
		mbrCardNumber = mbrCardNumber.padStart(14, "0");
	}

	const first13Digits = Number(mbrCardNumber.substring(0, 13));
	const modulusResult = first13Digits % 7;
	const fourteenthCharacter = mbrCardNumber.charAt(13);

	if (modulusResult == fourteenthCharacter) {
		return true;
	} else {
		return false;
	}
}
const sweepstakeConsentInput = document.getElementById("consent");
if (sweepstakeConsentInput) {
	sweepstakeConsentInput.addEventListener("change", function () {
		if (sweepstakeConsentInput.checked) {
			setFormMessageVisible(
				document.getElementById("cheers-error-checks"),
				false,
			);
		}
	});
}

function normalizeZipValue(value) {
	return String(value).replace(/\D/g, "").slice(0, 5);
}

function isZipValid(zipValue) {
	return normalizeZipValue(zipValue).length === 5;
}

function setZipFieldValidity(input, state) {
	if (!input) {
		return;
	}
	input.classList.remove("valid", "invalid");
	if (state === "valid") {
		input.classList.add("valid");
		input.setAttribute("aria-invalid", "false");
	} else if (state === "invalid") {
		input.classList.add("invalid");
		input.setAttribute("aria-invalid", "true");
	} else {
		input.setAttribute("aria-invalid", "false");
	}
}

function checkZip() {
	const inputField = document.getElementById("form_field_zip");
	if (!inputField) {
		return false;
	}

	const numericValue = normalizeZipValue(inputField.value);
	inputField.value = numericValue;

	if (numericValue.length < 5) {
		setZipFieldValidity(inputField, "neutral");
		return numericValue.length === 0;
	}

	const valid = isZipValid(numericValue);
	setZipFieldValidity(inputField, valid ? "valid" : "invalid");
	return valid;
}

const sweepstakeZipInput = document.getElementById("form_field_zip");
if (sweepstakeZipInput) {
	sweepstakeZipInput.addEventListener("input", checkZip);
}
